export const ROUTER_PUSH 					= 'ROUTER_PUSH'
export const ROUTER_REPLACE_AT_INDEX 		= 'ROUTER_REPLACE_AT_INDEX'
export const ROUTER_POP_TO_TOP 				= 'ROUTER_POP_TO_TOP'
export const ROUTER_REPLACE 				= 'ROUTER_REPLACE'
export const ROUTER_POP 					= 'ROUTER_POP'
export const ROUTER_MERGE_META				= 'ROUTER_MERGE_META'
export const ROUTER_POP_TO_ROUTE_AND_PUSH	= 'ROUTER_POP_TO_ROUTE_AND_PUSH'
export const ROUTER_REMOVE_CHILD			= 'ROUTER_REMOVE_CHILD'

let routes

export function setRoutes(routesp){
	routes = routesp
}

export function popRoute(meta=undefined){
	return {
		type: ROUTER_POP,
		meta: meta
	}
}

export function removeChildStack(name){
	return {
		type: ROUTER_REMOVE_CHILD,
		name: Array.isArray(name) ? name : [name]
	}
}

export function pushRoute(name, meta=undefined){
	return {
		type: ROUTER_PUSH,
		name: name,
		meta: Object.assign({}, _getMetaForRoute(name), meta)
	}
}

export function replaceRoute(name, meta=undefined){
	return {
		type: ROUTER_REPLACE,
		name: name,
		meta: Object.assign({}, _getMetaForRoute(name), meta)
	}
}

export function replaceRouteAtIndex(name, index){
	return {
		type: ROUTER_REPLACE_AT_INDEX,
		name: name,
		index: index
	}
}

export function popRouteToTop(){
	return {
		type: ROUTER_POP_TO_TOP
	}
}

export function routeMergeMeta(meta){
	return {
		type: ROUTER_MERGE_META,
		meta: meta
	}
}

export function popToRouteAndPush(toName, name, meta=undefined){
	return {
		type: ROUTER_POP_TO_ROUTE_AND_PUSH,
		to: toName,
		name: name,
		meta: Object.assign({}, _getMetaForRoute(name), meta)
	}
}

function _getMetaForRoute(route){
	return (routes && routes[route] && routes[route].meta) ? routes[route].meta : {}
}




// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/actions/router.js